import React from 'react';
import ReactDOM from 'react-dom';
import { SETTINGS } from "./GoPlanner/util/constants";
import GoPlanner from './GoPlanner/App';
import LiveStream from './LiveStream/App';
import PanelMap from './BillboardPanel/Map';
import Chart from './BillboardPanel/Chart';
import SuccessPopup from "./Campaign/SuccessPopup";
import HeaderBasketIcon from "./Campaign/HeaderBasketIcon";
import EnquirePage from "./Campaign/EnquirePage";
import AddButton from "./Campaign/AddButton";
import EnquireButton from "./Campaign/EnquireButton";
import LiveStreamButton from "./Campaign/LiveStreamButton";
import LiveStreamModal from "./Campaign/LiveStreamModal";

global._babelPolyfill = false;

const goPlannerPage = document.getElementById('go-planner-page');
if (goPlannerPage) {
    ReactDOM.render(
        <GoPlanner settings={JSON.parse(SETTINGS)} />,
        goPlannerPage
    );
}

const liveFeedPage = document.getElementById('live-stream-page');
if (liveFeedPage) {
    ReactDOM.render(
        <LiveStream />,
        liveFeedPage
    );
}
 
const panelMap = document.getElementById('panel-map');
if (panelMap) {
    const data = panelMap.dataset;
    ReactDOM.render(
        <PanelMap
            lat={parseFloat(data.lat)}
            lng={parseFloat(data.lng)}
            kml={data.kml}
            hideLabel
        />,
        panelMap
    );
}

const billboardCharts = document.querySelectorAll('.js-billboard-chart');
if (billboardCharts.length) {
    billboardCharts.forEach(chartElement => (
        ReactDOM.render(<Chart data={JSON.parse(chartElement.dataset.settings)} />, chartElement)
    ))
}

const panelAddButton = document.getElementById('panel-add-campaign-button');
if (panelAddButton) {
    ReactDOM.render(
        <AddButton
            panel={JSON.parse(panelAddButton.dataset.panel)}
            buttonClass="button primary"
            showText
        />,
        panelAddButton
    );
}

const panelLiveStreamButton = document.getElementById('panel-live-stream-button');
if (panelLiveStreamButton) {
    ReactDOM.render(
        <LiveStreamButton
            panel={JSON.parse(panelLiveStreamButton.dataset.panel)}
            active={true}
        />,
        panelLiveStreamButton
    );
}

const panelEnquireButton = document.getElementById('panel-enquire-button');
if (panelEnquireButton) {
    ReactDOM.render(
        <EnquireButton
            panel={JSON.parse(panelEnquireButton.dataset.panel)}
            buttonClass="button primary"
            showText
        />,
        panelEnquireButton
    );
}

const plannerPopup = document.getElementById('go-planner-popup');
if (plannerPopup) {
    ReactDOM.render(<SuccessPopup />, plannerPopup);
}

const livestreamModal = document.getElementById('livestream-modal');
if (livestreamModal) {
    ReactDOM.render(<LiveStreamModal />, livestreamModal);
}

const basketCounter = document.getElementById('planner-basket-counter');
if (basketCounter) {
    ReactDOM.render(<HeaderBasketIcon />, basketCounter);
}

const enquirePage = document.getElementById('enquire-page');
if (enquirePage) {
    const data = enquirePage.dataset;
    ReactDOM.render(
        <EnquirePage link={data.link} settings={JSON.parse(data.settings)} />,
        enquirePage
    );
}
